import { useNavigate } from 'react-router-dom';

interface UpgradeBannerProps {
    compact?: boolean;
}

export default function UpgradeBanner({ compact = false }: UpgradeBannerProps) {
    const navigate = useNavigate();

    if (compact) {
        return (
            <button
                onClick={() => navigate('/upgrade')}
                className="w-full py-3 px-4 bg-white border-2 border-primary-500 rounded-xl text-primary-600 font-semibold hover:bg-primary-50 transition-colors flex items-center justify-center gap-2"
            >
                <span>Unlock unlimited scans</span>
                <span>→</span>
            </button>
        );
    }

    return (
        <div className="card bg-gradient-to-r from-primary-500 to-primary-600 text-white border-0">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="font-bold text-lg">Go Pro!</h3>
                    <p className="text-primary-100 text-sm">Unlimited scans & more</p>
                </div>
                <button
                    onClick={() => navigate('/upgrade')}
                    className="bg-white text-primary-600 font-bold py-2 px-4 rounded-lg hover:bg-primary-50 transition-colors"
                >
                    Upgrade
                </button>
            </div>
        </div>
    );
}
